<template>
    <div class="Journalism">
        <!-- <div class="way">
            <el-row type="flex" class="row-bg" justify="center">
                <el-col :span="20">
                    <breadcrumb></breadcrumb>
                </el-col>
            </el-row>
        </div> -->
        <el-row type="flex" class="row-bg primary " justify="center">
            <el-col :span="20">
                <div class="headline">
                    <h3>{{ maindata.title }}</h3>
                    <p>
                        发表于 <span>{{ maindata.created | formatDate }}</span>
                    </p>
                </div>
                <div class="content">
                    <!-- <h3>尊敬的壹米滴答用户:</h3> -->
                    <!-- <img class="banner"
                         :src="maindata.image"> -->
                    <div class="innerhtml" v-html="content"></div>
                    <!-- <p>据中央气象台最新预报，未来三天，陕西南部、重庆东南部、湖北南部</p>
                    <div class="inscription">
                        <p>{{maindata.title}}</p>
                        <p>{{maindata.title}}</p>
                    </div> -->
                    <div class="btn">
                        <el-button
                            type="text"
                            class="btn-left"
                            :disabled="searchtoptitle == '0'"
                            @click="prod"
                            >上一篇：{{ searchtoptitle | textstate }}</el-button
                        >
                        <el-button
                            type="text"
                            :disabled="searchbottomtitle == '1'"
                            class="btn-right"
                            @click="next"
                            >下一篇：{{
                                searchbottomtitle | textstate
                            }}</el-button
                        >
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import breadcrumb from "@/components/breadcrumb";
import { querynewbyid, countaddarticle } from "@/api/homePage";
import Bus from "@/utils/bus";
export default {
    components: {
        breadcrumb
    },
    name: "Journalism",
    data() {
        return {
            maindata: [],
            ruleForm: {
                id: "",
                platform: "1"
            },
            content: "",
            activeId: {
                categoryId: ""
            },
            textlist: [],
            searchtoptitle: "",
            searchbottomtitle: ""
        };
    },
    watch: {
        //监听路由变化
        $route(to, from) {
        }
    },
    mounted() {},
    watch: {
        $route(to, from) {
            this.querymain();
            this.addCounts(this.$route.query.contentid);
        }
    },
    created() {
        this.ruleForm.id = this.$route.query.contentid;
        this.querymain();
        this.addCounts(this.$route.query.contentid);
        // this.queryselect();
    },
    methods: {
        prod() {
            this.ruleForm.id = this.maindata.upArticleId;
            this.$router.push({
                path: "/Journalism",
                query: {
                    id: this.$route.query.id,
                    contentid: this.ruleForm.id
                }
            });
            // this.querymain();
            // if (this.ruleForm.id !== "") {
            //     setTimeout(() => {
            //         Bus.$emit("gotop", "true");
            //     }, 100);
            // }
        },
        addCounts(id) {
            if (id) {
                countaddarticle(id)
                    .then(res => {
                        if (res.status === 2000) {
                        }
                    })
                    .catch(err => {});
            }
        },
        next() {
            this.ruleForm.id = this.maindata.downArticleId;
            // this.$router.push;
            this.$router.push({
                path: "/Journalism",
                query: {
                    id: this.$route.query.id,
                    contentid: this.ruleForm.id
                }
            });
            // if (this.ruleForm.id !== "") {
            //     setTimeout(() => {
            //         Bus.$emit("gotop", "true");
            //     }, 100);
            // }
        },
        querymain() {
            querynewbyid(this.ruleForm)
                .then(res => {
                    if (res.status === 2000) {
                        this.maindata = res.data;
                        this.content = this.maindata.osArticleContent.content;
                        this.searchtoptitle = this.maindata.upArticleName;
                        this.searchbottomtitle = this.maindata.downArticleName;
                    }
                })
                .catch(err => {});
        }
    }
};
</script>
<style lang="scss" scoped>
.Journalism {
    margin-bottom: 1px;
    .way {
        height: 50px;
        margin-top: -3px;
        background-color: #221814;
        .el-breadcrumb {
            line-height: 50px;
        }
        /deep/ .breadcrumb {
            li {
                font-weight: bold !important;
                color: #ffffff !important;
            }
        }
    }
    img {
        width: 100%;
    }
    .primary {
        .headline {
            text-align: center;
            margin: 40px;
            p {
                margin-top: 20px;
            }
        }
        .content {
            background-color: #f5f6f7;
            padding: 62px 63px;
            margin-bottom: 62px;
            .banner {
                margin-top: 39px;
            }
            // p {

            // }
            .innerhtml {
                // font-size: 15px;
                // color: #333;
                margin-top: 40px;
                // line-height: 22px;
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
            }
            .inscription {
                float: right;
                color: #221814;
                p:nth-child(1) {
                    margin-top: 60px;
                }
                p:nth-child(2) {
                    margin-top: 30px;
                }
            }
            .btn {
                margin-top: 140px;
                padding-bottom: 62px;
                .el-button {
                    display: block;
                    margin-left: 20px;
                }
                i {
                    font-size: 15px;
                }
                p {
                    display: block;
                    cursor: pointer;
                    color: #fda20c;
                    margin-top: 20px;
                }
                // .btn-left {
                //     width: 100%;
                //     display: inline-block;
                //     cursor: pointer;
                //     color: #fda20c;
                // }
                // .btn-right {
                //     display: inline-block;
                //     cursor: pointer;
                //     color: #fda20c;
                // }
            }
        }
    }
}
</style>
